import {
  CompanyChangesSocketMessage,
  OnReceiveSocketCompanyChangesEvent,
  useSearchQueryFilter,
} from '@aibees/elephant/hooks';
import { useSocketCompanyChanges } from '@aibees/elephant/hooks/company/use-socket-company-changes';
import { baseQueryClient } from '@aibees/shared/http';
import useSearchItemsStore from '@aibees/shared/store/search-items-store/search-items-store';
import { SearchItem } from '@aibees/shared/store/search-items-store/types';
import { useCallback, useEffect } from 'react';
import { CompanySearchResponse } from './types';
import { useBrowseUpdatedCompanies } from './use-browse-updated-companies';

export function useUpdateCompanySearchItems() {
  const { setUpdatedSearchItems } = useSearchItemsStore();
  const browseUpdatedCompaniesMutation = useBrowseUpdatedCompanies();
  const updatedCompanies = baseQueryClient.getQueryData<CompanySearchResponse>([
    useBrowseUpdatedCompanies.name,
  ]);
  const { params } = useSearchQueryFilter();

  const onEvent: OnReceiveSocketCompanyChangesEvent = useCallback(
    (_data: CompanyChangesSocketMessage) => {
      browseUpdatedCompaniesMutation.mutate();
    },
    [browseUpdatedCompaniesMutation, params]
  );

  useSocketCompanyChanges(onEvent);

  useEffect(() => {
    if (updatedCompanies?.content || updatedCompanies?.top) {
      const newItems = [
        ...(updatedCompanies?.top || []),
        ...(updatedCompanies?.content || []),
      ] as unknown as SearchItem[];
      setUpdatedSearchItems((prevItems) => {
        const newItemsIds = newItems.map((item) => item.id);

        // Keep existing items that don't have a matching ID in new items
        const itemsToKeep = prevItems.filter(
          (item) => !newItemsIds.includes(item.id)
        );

        // Return merged array: kept items + all new items (which replace any with same ID)
        return [...itemsToKeep, ...newItems];
      });
    }
  }, [updatedCompanies?.content, updatedCompanies?.top, setUpdatedSearchItems]);
}
